// src/utils/formatters.js — Shared formatting utilities

/**
 * Format a date string to a human-readable short date.
 * e.g. "2024-01-15" → "15 Jan 24"
 */
export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  if (!s || s === 'null') return '—';
  try {
    const dt = new Date(s);
    if (isNaN(dt.getTime())) return s;
    return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' });
  } catch { return s; }
}

/**
 * Format a full ISO datetime to a readable string.
 * e.g. "2024-01-15T10:30:00Z" → "15 Jan 24, 10:30"
 */
export function fmtDateTime(d) {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return '—';
    return dt.toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return '—'; }
}

/**
 * Format a relative time from now.
 * e.g. new Date() - 3 days → "3 days ago"
 */
export function timeAgo(d) {
  if (!d) return '—';
  try {
    const diff = Date.now() - new Date(d).getTime();
    const mins  = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days  = Math.floor(diff / 86400000);
    if (mins < 1)   return 'just now';
    if (mins < 60)  return `${mins}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 30)  return `${days}d ago`;
    return fmtDate(d);
  } catch { return '—'; }
}

/**
 * Format a file size in bytes to a human-readable string.
 * e.g. 1024000 → "1.0 MB"
 */
export function fmtFileSize(bytes) {
  if (!bytes || bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
}

/**
 * Truncate text with ellipsis.
 */
export function truncate(str, max = 60) {
  if (!str) return '';
  return str.length > max ? str.slice(0, max) + '…' : str;
}
